export default __webpack_public_path__ + "static/media/icon_terms_checked.35438a48.svg";